export default __webpack_public_path__ + "static/gmail-addon-add-new-contact-eff78f68ba9266fe03ef801b38a1e03b.mp4";